import CardWrapper from "./CardWrapper"
import { Flame, TrendingUp, TrendingDown, TriangleAlert, CircleCheck, Minus } from "lucide-react";
import styles from "../../styles/portfolioManagerDashboard.module.scss"

function RiskCard({ value, trend, trendLabel }) {
  return (
    <CardWrapper classNames={styles.riskCard}>
      <div className={styles.cardTop}>
        <span className={styles.label}>Projects at Risk</span>
        <div className={styles.cardMain}>
          <div className={`${styles.value} ${value > 0 ? styles.negative : styles.positive}`}>{value}</div>
          {
            value > 0 ?
            <div className={styles.iconBadge}>
              <TriangleAlert size={24} color="#dc2626" />
            </div>
            :
            <div className={styles.iconBadge} style={{ background: "#ecfdf5" }}>
              <CircleCheck size={24} color="#0d9f61" />
            </div>
          }

        </div>
      </div>
      <div className={styles.cardFooter}>
        <span className={`${styles.trendBadge} ${trend === 0 ? (value > 0 ? styles.negative : styles.positive) : trend >= 0 ? styles.negative : styles.positive}`}>
          {trend === 0
            ? <Minus size={12} />
            : trend >= 0 ? <TrendingUp size={12} /> : <TrendingDown size={12} />
          }
          {`${trend >= 0 ? '+' : ''}${trend}`}
        </span>
        <span className={styles.trendLabel}>{trendLabel}</span>
      </div>
    </CardWrapper>
  )
}

export default RiskCard
